

function getUrlSearch(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
}

export default {
  getUrlSearch
}



// WEBPACK FOOTER //
// ./src/libs/utils/GetUrl.js